import { isPlatformServer } from '@angular/common';
import type { OnDestroy, OnInit } from '@angular/core';
import { ChangeDetectionStrategy, Component, ElementRef, inject, Input, PLATFORM_ID } from '@angular/core';
import { Subject } from 'rxjs';

import { HeaderViewService } from 'components/organisms/header-v2/service/header-view.service';
import { ThemeDirective } from 'src/directives/theme/theme.directive';
import type { TFullColorScheme } from 'src/shared/types/color-schemes-and-themes';

import type { TTopBannerIcon } from './entities/types';

@Component({
    selector: 'website-top-banner',
    templateUrl: './top-banner.component.html',
    styleUrls: ['./top-banner.component.scss'],
    standalone: true,
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [ThemeDirective],
})
export class TopBannerComponent implements OnDestroy, OnInit {
    private readonly platformId = inject(PLATFORM_ID);
    private readonly headerViewService = inject(HeaderViewService);
    private readonly elementRef = inject(ElementRef);

    @Input() public text: string;
    @Input() public icon: TTopBannerIcon;
    @Input() public colorScheme: TFullColorScheme;
    @Input() public hasIcon = false;
    @Input() public hasCloseButton = false;

    public isClosed = false;
    public bannerColorScheme: TFullColorScheme;

    private readonly onDestroy$$ = new Subject();

    closeBanner() {
        this.isClosed = true;
        this.onDestroy$$.next(null);
        this.onDestroy$$.complete();
    }

    ngOnInit() {
        if (this.colorScheme === 'default') {
            this.bannerColorScheme = this.headerViewService.isFirstThemeDark() ? 'midnight' : 'white';
        } else {
            this.bannerColorScheme = this.colorScheme;
        }
    }

    public get height(): number {
        if (isPlatformServer(this.platformId)) {
            return 0;
        }

        return this.elementRef.nativeElement.getBoundingClientRect().height;
    }

    public ngOnDestroy(): void {
        this.onDestroy$$.next(null);
        this.onDestroy$$.complete();
    }
}
